import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// No style imports here; styles are loaded via index.css included in index.html
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)

